import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '20px 0 8px',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 20,
        paddingBottom: 12,
        borderBottom: '1px solid #EDEDF2',
    },
    headerIcon: {
        fontSize: 20,
        color: '#3F51B5',
    },
    headerTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#1A1A2E',
    },
    headerCount: {
        fontSize: 11,
        fontWeight: 600,
        color: '#3F51B5',
        backgroundColor: '#E8EAF6',
        borderRadius: 10,
        padding: '2px 8px',
        marginLeft: 4,
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '56px 24px',
        borderRadius: 12,
        backgroundColor: '#FAFAFC',
        border: '1px dashed #D5D5E0',
    },
    emptyIconWrapper: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: '#F0F0F7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 14,
    },
    emptyIcon: {
        fontSize: 28,
        color: '#9E9EB8',
    },
    emptyText: {
        fontSize: 13,
        color: '#78798E',
        fontWeight: 500,
    },
    timelineList: {
        position: 'relative',
        padding: 0,
        margin: 0,
        listStyle: 'none',
    },
    timelineItem: {
        display: 'flex',
        gap: 14,
        position: 'relative',
        paddingBottom: 20,
        '&:last-child': {
            paddingBottom: 0,
        },
        '&:last-child $connector': {
            display: 'none',
        },
    },
    dotColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 40,
        flexShrink: 0,
        paddingTop: 2,
    },
    avatar: {
        width: 34,
        height: 34,
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: '#E8EAF6',
        color: '#3F51B5',
        zIndex: 1,
        boxShadow: '0 0 0 3px #fff, 0 0 0 4px #E8EAF6',
    },
    connector: {
        width: 1.5,
        flex: 1,
        background: 'linear-gradient(to bottom, #D5D5E0, #EDEDF2)',
        marginTop: 6,
    },
    contentCard: {
        flex: 1,
        borderRadius: 10,
        border: '1px solid #EDEDF2',
        backgroundColor: '#fff',
        overflow: 'hidden',
        transition: 'box-shadow 0.15s ease',
        '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        },
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 16px',
        backgroundColor: '#FAFAFC',
        borderBottom: '1px solid #EDEDF2',
    },
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    userName: {
        fontSize: 13,
        fontWeight: 600,
        color: '#1A1A2E',
    },
    resetBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        fontSize: 10,
        fontWeight: 600,
        color: '#E65100',
        backgroundColor: '#FFF3E0',
        borderRadius: 4,
        padding: '1px 6px',
        letterSpacing: '0.3px',
    },
    resetBadgeIcon: {
        fontSize: 11,
    },
    timeStamp: {
        fontSize: 11,
        color: '#9E9EB8',
        fontWeight: 500,
        letterSpacing: '0.2px',
    },
    changesContainer: {
        padding: '10px 16px 12px',
    },
    changesLabel: {
        fontSize: 10,
        fontWeight: 600,
        color: '#9E9EB8',
        textTransform: 'uppercase',
        letterSpacing: '0.8px',
        marginBottom: 8,
    },
    changesGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
    },
    changeChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '4px 10px',
        borderRadius: 6,
        backgroundColor: '#F5F5FA',
        border: '1px solid #EDEDF2',
        maxWidth: '100%',
    },
    changeKey: {
        fontSize: 11,
        fontWeight: 500,
        color: '#78798E',
        whiteSpace: 'nowrap',
    },
    changeSeparator: {
        fontSize: 10,
        color: '#C5C5D3',
    },
    changeVal: {
        fontSize: 11,
        fontWeight: 600,
        color: '#1A1A2E',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 180,
    },
    changeValEmpty: {
        fontSize: 11,
        fontStyle: 'italic',
        color: '#B0B0C0',
    },
}));

export default useStyles;
